import "./App.css";
import "./styles/utils.css";
import "./styles/position.css";
import "./styles/colors.css";
import "./styles/dimanstion.css";
import "./styles/fonts.css";
import "./styles/measurements.css";
import "./styles/dropDown.css";
import CustomAppBar from "./shared/CustomAppBar";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
  // useLocation,
} from "react-router-dom";
import QueryParam from "./Components/queryParam";
import BasketRedirectWatcher from "./Components/BasketRedirectWatcher";
import LanguageProvider from "./context/language/LanguageContext";
import React, { useEffect } from "react";
import appConst from "./Utilities/appConst.json";
import Alert from "./shared/Alert";
import CustomModal from "./shared/CustomModal";
import Loader from "./shared/Loader";
import stepper from "./Utilities/stepperUtil";
import { useDispatch, useSelector } from "react-redux";
import Footer from "./Components/Footer";
import { getNewsletterData } from "./store/userSlice";
import { getLicenseData } from "./store/licenseSlice";
import useBraze from "./hooks/useBraze";
import { useEventGA4Map } from "./hooks/useEventGA4Map";
import useDatadogRum from "./hooks/useDatadogRum";
import Marketing from "./pages/Marketing";
import Basket from "./pages/Basket";
import NotFoundPage from "./pages/NotFoundPage";
import Success from "./pages/Success";
import PaymentError from "./pages/PaymentError";
import CreditGuard from "./pages/CreditGuard";
import PersonalDetails from "./pages/PersonalDetails";
import SubShipping from "./pages/SubShipping";
import Shipping from "./pages/Shipping";
import Summary from "./pages/Summary";
import EmptyBasketPage from "./pages/EmptyBasketPage";

const App = () => {
  const dispatch = useDispatch();
  // Initialize Braze SDK
  useBraze();
  // Mount GA4 listener: drains state.mode.valueGA4 into window.dataLayer (GTM).
  // Side-effect only — the return value is intentionally unused. Do not remove.
  useEventGA4Map();
  // Initialize Datadog RUM (prod-only) — auto-captures device.type/os/browser
  useDatadogRum();
  // const navigate = useNavigate();
  // const location = useLocation();

  const guardIndex = useSelector((state) => state.guard.guardIndex);
  const isError = useSelector((state) => state.error.isError);
  const isBasketEmpty = useSelector((state) => state.error.isBasketEmpty);
  const turms = useSelector((state) => state.user.turms);
  const footerContentHeight = useSelector(
    (state) => state.footer.footerContentHeight
  );
  const quary = useSelector((state) => state.mode.quary);
  const isLoaderShow = useSelector((state) => state.loader.isShow);
  const isNewsletter = useSelector((state) => state.user.isNewsletter);
  const isBirthdayDate = useSelector((state) => state.user.isBirthdayDate);
  const footerIsShow = useSelector((state) => state.footer.isShow);
  const showIframe = useSelector((state) => state.creditGuard.showIframe);
  const showHeader = useSelector((state) => state.mode.showHeader) === "true";
  const language = useSelector((state) => state.mode.language);
  const direction = useSelector((state) => state.mode.direction);
  const isMarketingStripeVisible = useSelector(
    (state) => state.basket.isMarketingStripeVisible
  );
  const isBasketToolbarVisible = useSelector(
    (state) => state.basket.isBasketToolbarVisible
  );
  const isShippingAlertVisible = useSelector(
    (state) => state.basket.isShippingAlertVisible
  );

  const footerSpace = footerContentHeight ? footerContentHeight + 21 : 0;
  const pageHeight = showIframe
    ? "100%"
    : `calc(100dvh - 56px - 7px - ${footerSpace}px)`; // total_hight - header - stepper
  const innerNoFooterPageHeight = "calc(100dvh - 56px)"; // total_hight - header

  const product = sessionStorage.getItem(appConst.PRODUCT); //appConst.ORDERS_UNION
  const stepperIsShow = guardIndex >= 0;

  useEffect(() => {
    if (
      window.location.pathname != appConst.NINTH_PAGE &&
      window.location.pathname != appConst.ELEVNTH_PAGE
    ) {
      dispatch(getNewsletterData());
    }
    window.showPrevScreen = lupaNativeShowPrevScreen;
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'URL_UPDATE') {
        sessionStorage.setItem('PARENT_URL', event.data.url);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const lupaNativeShowPrevScreen = () => {
    const pageName = window.location.pathname;

    try {
      if (
        pageName === appConst.FIRST_PAGE ||
        (((isNewsletter && isBirthdayDate) ||
          product == appConst.ORDERS_UNION) &&
          pageName === appConst.SECOND_PAGE) ||
        pageName === appConst.ELEVNTH_PAGE ||
        pageName === appConst.TWELTH_PAGE ||
        pageName === appConst.THIRTEEN_PAGE
      ) {
        window.LupaNative.exit();
      } else {
        window.history.back();
      }
    } catch (e) {
      window.LupaNative.exit();
    }
  };

  useEffect(() => {
    if (isNewsletter != null && isBirthdayDate != null && product != null) {
      window.showPrevScreen = lupaNativeShowPrevScreen;
    }
  }, [isNewsletter, isBirthdayDate, product]);

  useEffect(() => {
    if (language) {
      dispatch(getLicenseData(language));
    }
  }, [language]);

  const isNoFooterStepperMode = !footerIsShow && stepperIsShow;
  const isMainStepperMode = !isError && !isBasketEmpty && stepperIsShow;
  const flexBodyModeClass = isNoFooterStepperMode
    ? "flexBodyModeNoFooter"
    : isMainStepperMode
      ? "flexBodyModeMain"
      : "flexBodyModeFallback";
  const flexBodyDynamicStyle = isNoFooterStepperMode
    ? {
        "--flex-body-xs-height": pageHeight,
      }
    : isMainStepperMode
      ? {
          "--flex-body-xs-height": "auto",
          "--flex-body-xs-margin-top": `calc(${showHeader ? "56px" : "0px"} + 3px)`,
          "--flex-body-sm-margin-top": `max(calc(${showHeader ? "56px" : "0px"} + 3px), calc(20vh - ${40 + (isMarketingStripeVisible ? 40 : 0) + (isBasketToolbarVisible ? 40 : 0) + (isShippingAlertVisible ? 40 : 0)}px))`,
        }
      : {
          "--flex-body-xs-height": innerNoFooterPageHeight,
        };

  return (
    <LanguageProvider>
      <Router>
        <Alert></Alert>
        <CustomModal
          title={appConst.POLICY_APPROVAL_TITLE}
          content={turms}
        ></CustomModal>
        {isLoaderShow && <Loader />}
        <CustomAppBar></CustomAppBar>
        <div className="flexApp flexAppDynamicHeight" dir={direction}>
          <div
            className={`${!isError && !isBasketEmpty && stepperIsShow
                ? "flexBodyApp"
                : "flexBodyAppBottomFooter"
              } flexBodyDynamic ${flexBodyModeClass}`}
            style={flexBodyDynamicStyle}
          >
            <QueryParam></QueryParam>
            <BasketRedirectWatcher />
            <Switch>
              <Route exact path="/">
                <Redirect
                  to={{
                    pathname:
                      (isNewsletter && isBirthdayDate) ||
                      product == appConst.ORDERS_UNION
                        ? `${appConst.SECOND_PAGE}`
                        : `${appConst.FIRST_PAGE}`,
                    search: quary,
                  }}
                />
              </Route>
              {!isError &&
                !isBasketEmpty &&
                stepper.get(appConst.SECOND_PAGE) <= guardIndex && (
                  <Route path={appConst.SECOND_PAGE} component={Basket}></Route>
                )}
              {/* {stepper.get(appConst.THIRD_PAGE) <= guardIndex && <Route exact path={appConst.THIRD_PAGE} component={AppsaleMaster}>
                </Route>} */}
              {!isError &&
                !isBasketEmpty &&
                stepper.get(appConst.FIFTH_PAGE) <= guardIndex && (
                  <Route
                    path={appConst.FIFTH_PAGE}
                    component={Shipping}
                  ></Route>
                )}
              {!isError &&
                !isBasketEmpty &&
                stepper.get(appConst.SIXTH_PAGE) <= guardIndex && (
                  <Route
                    path={appConst.SIXTH_PAGE}
                    component={SubShipping}
                  ></Route>
                )}
              {!isError &&
                !isBasketEmpty &&
                stepper.get(appConst.SEVENTH_PAGE) <= guardIndex && (
                  <Route
                    path={appConst.SEVENTH_PAGE}
                    component={PersonalDetails}
                  ></Route>
                )}
              {!isError &&
                !isBasketEmpty &&
                stepper.get(appConst.EIGHTH_PAGE) <= guardIndex && (
                  <Route
                    path={appConst.EIGHTH_PAGE}
                    component={Summary}
                  ></Route>
                )}
              {!isError &&
                !isBasketEmpty &&
                stepper.get(appConst.NINTH_PAGE) <= guardIndex && (
                  <Route
                    path={appConst.NINTH_PAGE}
                    component={CreditGuard}
                  ></Route>
                )}
              {!isError &&
                !isBasketEmpty &&
                stepper.get(appConst.TENTH_PAGE) <= guardIndex && (
                  <Route
                    path={appConst.TENTH_PAGE}
                    component={PaymentError}
                  ></Route>
                )}
              {!isError &&
                !isBasketEmpty &&
                stepper.get(appConst.ELEVNTH_PAGE) <= guardIndex && (
                  <Route
                    path={appConst.ELEVNTH_PAGE}
                    component={Success}
                  ></Route>
                )}
              {!isError && !isBasketEmpty && (
                <Route path={appConst.FIRST_PAGE} component={Marketing}></Route>
              )}
              {isError && (
                <Route
                  path={appConst.TWELTH_PAGE}
                  component={NotFoundPage}
                ></Route>
              )}
              {isBasketEmpty && (
                <Route
                  path={appConst.THIRTEEN_PAGE}
                  component={EmptyBasketPage}
                ></Route>
              )}
              {isError && (
                <Route path="*">
                  <Redirect
                    to={{
                      pathname: appConst.TWELTH_PAGE,
                    }}
                  />
                </Route>
              )}
              {isBasketEmpty && (
                <Route path="*">
                  <Redirect
                    to={{
                      pathname: appConst.THIRTEEN_PAGE,
                    }}
                  />
                </Route>
              )}
            </Switch>
          </div>
          {footerIsShow && (
            <div className="flexFooterApp">
              <Footer />
            </div>
          )}
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
